/*
 * sale-badge.js  (wersja: Undress Code INTERNATIONAL)
 * ---------------------------------------------------------------------------
 * Pokazuje baner "SALE" (.product-label.sale) na kartach produktów w siatce,
 * które mają PRZECENIONĄ cenę robioną przez aplikację SneakPeek Early Access
 * (lub inny skrypt rabatowy) zamiast przez natywne compare_at_price w Shopify.
 *
 * Dlaczego to jest potrzebne:
 *   Natywny baner w snippets/product-label.liquid pojawia się tylko gdy
 *   product.compare_at_price > product.price. Kampanie SneakPeek NIE ruszają
 *   cen w Shopify (price == compare_at_price) — appka podmienia cenę dopiero
 *   w przeglądarce (dekoruje DOM), a rabat nakłada kodem w koszyku. Liquid
 *   nie ma więc jak pokazać banera. Ten skrypt dokłada baner na podstawie
 *   WIDOCZNEJ przeceny (przekreślona cena / atrybuty dekoracji SneakPeek),
 *   więc baner pojawia się dokładnie wtedy, kiedy klient widzi przecenioną
 *   cenę — niezależnie od tego, który skrypt / aplikacja ją wylicza.
 *
 * Bezpieczeństwo:
 *   - Skrypt NIGDY nie zmienia ceny (tylko dokłada etykietę) → nie może
 *     wywołać podwójnego rabatu.
 *   - Pomija karty, które już mają baner sale/sold-out (brak duplikatów na
 *     produktach z natywnym compare_at_price).
 *   - Gdy appka cofnie dekorację (koniec kampanii), baner jest zdejmowany.
 */
(function () {
  'use strict';

  // Tekst etykiety pobierany z tłumaczeń motywu (ustawiany w theme.liquid),
  // z fallbackiem na wypadek gdyby zmienna nie została podstawiona.
  var SALE_TEXT = (window.T4E_SALE_LABEL && String(window.T4E_SALE_LABEL).trim()) || 'Sale';

  var BLOCK_SELECTOR = '.product-block, .collection-block';
  var ADDED_CLASS = 't4e-js-sale-label';

  // Znaczniki widocznej przeceny wewnątrz kontenera ceny:
  //  - .was-price / s / del        → klasyczne przekreślenie (motyw lub skrypt)
  //  - data-early-access-*         → dekoracja aplikacji SneakPeek Early Access
  //    (created-compare = dołożone przekreślenie, percent = % rabatu na grupie)
  var DISCOUNT_SELECTOR = [
    '.was-price',
    's',
    'del',
    '[data-early-access-created-compare]',
    '[data-early-access-percent]'
  ].join(', ');

  // Karta jest "przeceniona", jeśli w cenie widać przekreśloną cenę pierwotną
  // lub dekorację rabatową SneakPeek.
  function blockIsDiscounted(block) {
    var price = block.querySelector('.price, .price-area');
    if (!price) return false;
    if (price.querySelector(DISCOUNT_SELECTOR)) return true;
    // Dekoracja może wylądować atrybutem na samym kontenerze ceny:
    if (price.hasAttribute('data-early-access-percent')) return true;
    return false;
  }

  // Czy karta ma już jakąkolwiek etykietę, która ma priorytet nad "sale"?
  function alreadyLabelled(block) {
    return !!block.querySelector(
      '.product-label.sale, .product-label.unavailable, .' + ADDED_CLASS
    );
  }

  // Miejsce wstawienia — dokładnie tam, gdzie robi to motyw (layout "standard").
  function labelTarget(block) {
    return block.querySelector('.image__first') || block.querySelector('.image') || null;
  }

  function buildLabel() {
    var outer = document.createElement('span');
    outer.className = 'product-label sale ' + ADDED_CLASS;
    var inner = document.createElement('span');
    inner.textContent = SALE_TEXT;
    outer.appendChild(inner);
    return outer;
  }

  function processBlock(block) {
    if (!block) return;

    var discounted = blockIsDiscounted(block);

    // SneakPeek potrafi cofnąć dekorację na żywo (koniec / wygaśnięcie
    // kampanii) — wtedy zdejmujemy nasz baner, żeby nie kłamał.
    if (!discounted) {
      var stale = block.querySelector('.' + ADDED_CLASS);
      if (stale && stale.parentNode) stale.parentNode.removeChild(stale);
      return;
    }

    if (alreadyLabelled(block)) return;

    var target = labelTarget(block);
    if (!target) return;

    // W tym motywie "sale" ma priorytet nad "new" — jeśli jest baner NEW,
    // zamieniamy go na SALE (spójnie z logiką product-label.liquid).
    var newLabel = block.querySelector('.product-label--new');
    if (newLabel && newLabel.parentNode) newLabel.parentNode.removeChild(newLabel);

    target.insertBefore(buildLabel(), target.firstChild);
  }

  function scanAll() {
    var blocks = document.querySelectorAll(BLOCK_SELECTOR);
    for (var i = 0; i < blocks.length; i++) processBlock(blocks[i]);
  }

  // Debounce, żeby wiele mutacji naraz wywołało tylko jeden przelot.
  // Używamy setTimeout (a NIE requestAnimationFrame) — rAF jest wstrzymywany
  // w kartach w tle, przez co baner mógłby się nie pojawić, gdy przecena
  // zostanie policzona zanim karta stanie się widoczna.
  var scheduled = false;
  function scheduleScan() {
    if (scheduled) return;
    scheduled = true;
    window.setTimeout(function () { scheduled = false; scanAll(); }, 50);
  }

  function init() {
    scanAll();

    // SneakPeek dekoruje cenę PO załadowaniu strony (i po fetchu pricingu),
    // dlatego obserwujemy DOM i domykamy baner, gdy pojawi się przecena.
    if (window.MutationObserver && document.body) {
      var mo = new MutationObserver(function (mutations) {
        for (var i = 0; i < mutations.length; i++) {
          var m = mutations[i];
          if (m.type === 'childList' && (m.addedNodes.length || m.removedNodes.length)) {
            scheduleScan();
            return;
          }
          if (m.type === 'attributes') {
            scheduleScan();
            return;
          }
        }
      });
      mo.observe(document.body, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['data-early-access-percent', 'data-early-access-created-compare']
      });
    }

    // Zmiana wariantu / doładowanie sekcji / infinite scroll.
    document.addEventListener('shopify:section:load', scheduleScan);
    document.addEventListener('variant:change', scheduleScan);
    window.addEventListener('load', scheduleScan);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();